import VulnerabilityDetailsSubTopbarTop from './VulnerabilityDetailsSubTopBar';

export { VulnerabilityDetailsSubTopbarTop };
export default VulnerabilityDetailsSubTopbarTop;
